(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/assets/javascripts/pay.js') >= 0) return;  svs.modules.push('/components/tur/wager/assets/javascripts/pay.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
(svs => {
  svs.tur.wager = _objectSpread(_objectSpread({}, svs.tur.wager), {}, {
    async pay(_ref) {
      let {
        wager,
        wagerprops,
        success,
        apiSuccess,
        error,
        cannotBeCancelled,
        confirmMessage,
        confirmTitle,
        abortCallback,
        noConfirmDialog,
        noSuccessDialog,
        extraSuccessMessage
      } = _ref;
      svs.tur.wager.logger.debug("paywager wager:".concat(JSON.stringify(wager)));
      svs.tur.wager.logger.debug("paywager wagerprops:".concat(JSON.stringify(wagerprops)));
      if (svs.core.userSession.isBlocked()) {
        svs.tur.wager.logger.info('User is blocked in NAR. Denying payment.');
        svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
        return;
      } else if (svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dayTimeLimit && svs.day_time_limit.data.dayTimeLimit.dayTimeExpired) {
        svs && svs.accountservices && svs.accountservices.day_time_limit && svs.accountservices.day_time_limit.notices && svs.accountservices.day_time_limit.notices.pay();
        return;
      }
      success = typeof success === 'function' ? success : undefined;
      error = typeof error === 'function' ? error : undefined;
      this.trackingWager = {
        productName: this.CONSTANTS.simpleProductName[wagerprops.productId],
        wagerId: 0,
        totalPrice: 0,
        bets: []
      };
      this.wager = wager;
      this.wagerprops = wagerprops;
      this.success = success;
      this.apiSuccess = apiSuccess;
      this.error = error;
      this.noConfirmDialog = noConfirmDialog;
      this.noSuccessDialog = noSuccessDialog;
      this.balance = 0;
      this.extraSuccessMessage = extraSuccessMessage;
      this.togglePayButton(false);

      let calculatedBetAmount = 0;
      wager.bets && wager.bets.forEach(bet => {
        calculatedBetAmount += isNaN(parseInt(bet.betAmountSalesGroup1, 10)) ? 0 : parseInt(bet.betAmountSalesGroup1, 10);
        calculatedBetAmount += isNaN(parseInt(bet.betAmountSalesGroup2, 10)) ? 0 : parseInt(bet.betAmountSalesGroup2, 10);
      });
      const extraParams = {
        amount: this.wagerprops.betAmount || calculatedBetAmount,
        product: this.CONSTANTS.simpleProductName[wagerprops.productId],
        weeks: this.wagerprops.extradata && this.wagerprops.extradata.rounds || 1,
        subscription: false,
        gift: false,
        branding: this.CONSTANTS.simpleProductName[wagerprops.productId]
      };

      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs$accountservices, _svs$accountservices$;
        await (svs === null || svs === void 0 || (_svs$accountservices = svs.accountservices) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.onboardingHandler) === null || _svs$accountservices === void 0 || (_svs$accountservices$ = _svs$accountservices.setupExtraData) === null || _svs$accountservices$ === void 0 ? void 0 : _svs$accountservices$.call(_svs$accountservices, {
          extraData: extraParams
        }));
        svs.events.publish('/loader/show');
        svs.components.account_balance.get(balance => {
          this.makePayment({
            accountbalance: balance,
            wager: this.wager,
            wagerprops: this.wagerprops,
            cannotBeCancelled,
            confirmMessage,
            confirmTitle,
            abortCallback
          });
        });
      }
    },
    makePayment(_ref2) {
      let {
        accountbalance,
        wager,
        wagerprops,
        cannotBeCancelled,
        confirmMessage,
        abortCallback
      } = _ref2;
      this.wager = wager;
      this.wagerprops = wagerprops;
      this.balance = svs.utils.format.CurrencyFromJupiterString(accountbalance);
      if (!this.wagerprops || !this.wagerprops.productId) {
        throw new Error('No productId provided');
      }

      this.payObject = {
        method: 'POST',
        path: '/wager/9/wagers',
        data: this.wager
      };

      if (svs.tur.wager.data && _.isEqual(this.wager, svs.tur.wager.data.lastwager) && new Date().getTime() - svs.tur.wager.data.lastwagertime.getTime() < 300) {
        svs.events.publish('/loader/hide');
        svs.tur.wager.logger.info('doubleclick payment attempt');
        return false;
      }
      svs.tur.wager.data = {
        lastwager: this.wager,
        lastwagertime: new Date()
      };
      let bet = {};
      switch (this.wagerprops.productId) {
        case 'LORLOTTO':
        case 'ONSLOTTO':
          {
            const day = this.wagerprops.productId === 'LORLOTTO' ? 'Lördag' : 'Onsdag';
            _.each(this.wager.bets, bet => {
              this.trackingWager.totalPrice += svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup1) + svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup2);
            });
            const lotto1 = {
              productName: "Lotto 1 ".concat(day),
              productId: this.wagerprops.productId,
              price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[0].betAmountSalesGroup1),
              numberOfRows: 1,
              extraData: this.wagerprops.extradata
            };
            this.trackingWager.bets.push(lotto1);
            if (this.wager.bets[0].lottoBoards && this.wager.bets[0].lottoBoards[0].participation === 'L1L2' || this.wager.bets[0].egnaRaderParticipation && this.wager.bets[0].egnaRaderParticipation === 'L1L2') {
              const lotto2 = {
                productName: "Lotto 2 ".concat(day),
                productId: "".concat(this.wagerprops.productId, "2"),
                price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[0].betAmountSalesGroup2),
                numberOfRows: 1,
                extraData: this.wagerprops.extradata
              };
              this.trackingWager.bets.push(lotto2);
            }
            if (this.wager.bets.length > 1) {
              const lottojoker = {
                productName: "Joker ".concat(day),
                productId: this.wager.bets[1].productId,
                price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[1].betAmountSalesGroup1),
                numberOfRows: 1,
                extraData: this.wagerprops.jokerextradata || this.wagerprops.extradata
              };
              this.trackingWager.bets.push(lottojoker);
            }
            break;
          }
        case 'VIKING':
          {
            _.each(this.wager.bets, bet => {
              this.trackingWager.totalPrice += svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup1);
            });
            bet = {
              productName: this.CONSTANTS.productName[this.wagerprops.productId],
              productId: this.wagerprops.productId,
              price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[0].betAmountSalesGroup1),
              numberOfRows: 1,
              extraData: this.wagerprops.extradata
            };
            this.trackingWager.bets.push(bet);
            if (this.wager.bets.length > 1) {
              const vikingjoker = {
                productName: 'Joker Onsdag',
                productId: this.wager.bets[1].productId,
                price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[1].betAmountSalesGroup1),
                numberOfRows: 1,
                extraData: this.wagerprops.jokerextradata || this.wagerprops.extradata
              };
              this.trackingWager.bets.push(vikingjoker);
            }
            break;
          }
        case 'ELOTTO':
          bet = {
            productName: this.CONSTANTS.productName[this.wagerprops.productId],
            productId: this.wagerprops.productId,
            price: svs.utils.format.CurrencyFromJupiterString(this.wager.bets[0].betAmountSalesGroup1),
            numberOfRows: 1,
            extraData: this.wagerprops.extradata
          };
          this.trackingWager.totalPrice = bet.price;
          this.trackingWager.bets.push(bet);
          break;
        case 'KENO':
          {
            _.each(this.wager.bets, bet => {
              this.trackingWager.totalPrice += svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup1) + svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup2);
            });
            const kenoRow = {
              productName: this.CONSTANTS.productName[this.wagerprops.productId],
              productId: this.wagerprops.productId,
              price: this.trackingWager.totalPrice,
              numberOfRows: 1,
              extraData: this.wagerprops.extradata
            };
            this.trackingWager.bets.push(kenoRow);
            break;
          }
        default:
      }

      let betAmount = svs.utils.format.CurrencyFromJupiterString(this.trackingWager.totalPrice);
      if (this.wagerprops.betAmount) {
        betAmount = this.wagerprops.betAmount;
      }
      svs.events.publish('/loader/hide');

      if (this.hasOwnProperty('balance') && betAmount > this.balance && !this.wager.voucherId) {
        this.showNoMoneyMessage.call(this, this.balance, betAmount, abortCallback);
      } else {
        if (this.noConfirmDialog) {
          this.sendWager();
        } else {
          this.confirmDialog({
            isTicket: wagerprops.isTicket || false,
            isVoucher: wagerprops.isVoucher || false,
            product: wagerprops.productName || this.CONSTANTS.simpleProductName[this.wagerprops.productId],
            price: betAmount,
            balance: this.balance,
            cannotBeCancelled,
            confirmMessage,
            abortCallback
          });
        }
      }
    },
    sendWager(callback) {
      if (this.wagerprops.productId === 'TRISS' || this.wagerprops.productId === 'SKRKRY' || this.wagerprops.productId === 'KENOXPRESS') {
        callback && callback();
        this.success && this.success();
        return;
      }
      svs.events.publish('/loader/show');
      svs.core.jupiter.call(this.payObject, data => {
        this.togglePayButton(true);
        svs.tur.wager.logger.info("success wagerid:".concat(data.wagerClientSerial, ", product:").concat(this.CONSTANTS.productName[this.wagerprops.productId]));
        this.trackingWager.wagerId = data.wagerClientSerial;
        if (!this.wagerprops.noAccountbalanceUpdate) {
          if (!this.wagerprops.syndicateId) {
            svs.components.account_balance.set(svs.utils.format.CurrencyFromJupiterString(data.accountBalance));
          }
        }
        this.trackGA(this.trackingWager);
        svs.events.publish('/loader/hide');
        callback && callback();
        this.noSuccessDialog ? this.success(data) : this.successDialog(data);
        typeof this.apiSuccess === 'function' && this.apiSuccess(data);
      }, (jqXHR, textStatus, errorThrown) => {
        this.togglePayButton(true);
        svs.tur.wager.logger.warn("failure (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
        const response = JSON.parse(jqXHR.responseText);
        svs.events.publish('/loader/hide');
        let errorcode;
        if (response.error && !response.error.code) {
          errorcode = 1;
          response.error.code = '1';
        } else if (typeof response.error.code === 'number') {
          errorcode = response.error.code;
        } else {
          errorcode = parseInt(response.error.code.replace(/\s/g, ''), 10);
        }
        callback && callback();
        this.error && this.error();
        this.handleError(errorcode);
      });
    }
  });
})(svs);

 })(window);